import { render, staticRenderFns, recyclableRender, components } from "./home-nav.vue?vue&type=template&id=1424eb3e&scoped=true&"
var renderjs
import script from "./home-nav.vue?vue&type=script&lang=js&"
export * from "./home-nav.vue?vue&type=script&lang=js&"
import style0 from "./home-nav.vue?vue&type=style&index=0&id=1424eb3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1424eb3e",
  null,
  false,
  components,
  renderjs
)

export default component.exports